export default "__VITE_ASSET__27V4Mi$x__"